import Header from "@/components/Header";
import UserDataSection from "@/components/UserDataSection";

const Dashboard = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <UserDataSection />
      </main>
    </div>
  );
};

export default Dashboard; 